import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { BagWarning } from '../BagWarning';

/**
 * Warning message that the order time cannot be bumped as its for tomorrow.
 */
export const BagNextDayOrderWarning = (props: BagNextDayOrderWarningProps) => {
  const { message, onClose } = props;
  const { formatMessage } = useIntl();

  return (
    <BagWarning
      message={message}
      accessibilityLabel={formatMessage(messages.accessibilityLabel)}
      closeAccessibilityLabel={formatMessage(messages.cta)}
      cta={formatMessage(messages.cta)}
      onClose={onClose}
      onCtaPress={onClose}
    />
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  message: {
    defaultMessage:
      'Heads up - Unfortunately, the store is closing and orders can’t be placed for today. Please select a future date or time to continue.',
    description: 'Bag | Order for tomorrow warning | Message',
  },
  cta: {
    defaultMessage: 'Got it',
    description: 'Bag | Order for tomorrow warning | CTA',
  },
  accessibilityLabel: {
    defaultMessage: 'Confirm future time',
    description: 'Bag | Order for tomorrow warning | a11y',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type BagNextDayOrderWarningProps = {
  message: string;
  onClose: () => void;
};
